import React from "react";
import { useIntersectionObserver } from "usehooks-ts";

function withLazyLoad<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- any is needed to make extends infer prop types
  T extends React.ComponentType<any>,
  Props extends React.ComponentProps<T>,
>(Component: T) {
  return ({
    height,
    offset,
    ...props
  }: {
    height: number;
    offset: number;
  } & Props) => {
    // Convert offset to rootMargin (px or %), and height to style
    const rootMargin = typeof offset === "number" ? `${offset}px` : offset;
    // We'll use threshold=0 for default, but could allow customization
    const { ref, isIntersecting } = useIntersectionObserver({
      rootMargin,
      threshold: 0,
    });
    return (
      <div ref={ref} style={{ minHeight: height }}>
        {isIntersecting ? <Component {...(props as Props)} /> : null}
      </div>
    );
  };
}

export default withLazyLoad;
